import { constants } from "@newsela/angelou";

const red50 = constants.colors.ui.red[50];
const red600 = constants.colors.ui.red[600];

export const actionCss = {
  backgroundColor: red50,
  color: red600,
  padding: "4px,",

  "& > span": {
    fontWeight: 400,
    fontSize: "16px",
  },
};

export const iconCss = {
  path: {
    fill: "currentColor",
  },
};
